import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  selectors as OrganizationsSelectors,
  actions as OrganizationsActions,
} from 'data/organizations'
import { selectors as ConfigSelectors } from 'data/config'
import { trackCopyInviteLink } from 'data/analytics/actions'

import { LinkCopiable } from 'components/base'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import * as Icons from 'components/Utils/Icons'
import { Button, Text } from 'components/base'
import { Input } from 'components/Utils/Form'

export class OpenInviteLink extends Component {
  render() {
    const {
      generateInviteToken,
      removeInviteToken,
      inviteToken,
      organization,
      boardingAppRoot,
    } = this.props

    const link = `${boardingAppRoot}/organization/join-link/${
      organization.domain
    }/${inviteToken}/default`
    // The default is there for tracking purposes. Will be sent in SIGNED_UP event inside the joinOrigin parameter.
    // To distinguish user joining with the join-link from 'email', 'slack' or any other way (e.g 'default')
    return (
      <div>
        <Text.Section className="margin-bottom-small">Invite link</Text.Section>
        <Text.Corpus className="margin-bottom-small">
          Anyone can use this link to join{' '}
          <span className="bold">{organization.domain}</span> on Slite.
        </Text.Corpus>
        <div className="flexbox flexbox-align-center">
          {inviteToken ? (
            <div className="flexbox-grow flexbox flexbox-align-center">
              <div
                className="flexbox-grow flexbox flexbox-align-center  background-shade-50 padding-vertical-normal"
                style={{ borderRadius: '4px 0 0 4px', height: 50 }}
              >
                <Input
                  value={link}
                  readOnly
                  className="flexbox-grow shade-20 font-weight-medium ellipsis"
                  size="normal"
                  style={{
                    minWidth: 270,
                    padding: 15,
                    border: 'none',
                    backgroundColor: 'transparent',
                  }}
                />
              </div>
              <div onClick={() => this.props.trackCopyInviteLink()}>
                <LinkCopiable
                  style={{
                    borderRadius: '0 4px 4px 0',
                    height: 50,
                    boxShadow: 'none',
                  }}
                  link={link}
                >
                  Copy
                </LinkCopiable>
              </div>
              <TooltipOnHover
                id={`remove invite token`}
                tooltipContent="Deactivate link. Nobody will be able to join your team from it anymore."
                placement="right"
              >
                <div
                  onClick={() => removeInviteToken()}
                  className="padding-normal shade-30 red-on-hover pointer flexbox flexbox-centered"
                >
                  <Icons.DeleteIcon size={16} />
                </div>
              </TooltipOnHover>
            </div>
          ) : (
            <div className="flexbox-grow flexbox flexbox-align-center">
              <Button.Primary
                onClick={() => generateInviteToken()}
                className="flexbox-no-grow font-weight-bold"
                style={{
                  minWidth: 200,
                }}
              >
                Generate
              </Button.Primary>
            </div>
          )}
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    inviteToken: OrganizationsSelectors.getInviteToken(state),
    organization: OrganizationsSelectors.getOrganization(state),
    boardingAppRoot: ConfigSelectors.getBoardingAppRoot(state),
  }
}

const mapDispatchToProps = {
  generateInviteToken: OrganizationsActions.generateInviteToken,
  removeInviteToken: OrganizationsActions.removeInviteToken,
  trackCopyInviteLink,
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(OpenInviteLink)
